<template>
	<el-dialog :visible.sync="dialogVisible" title="批量删除样品" :close-on-click-modal="false" :append-to-body="true" width="520px">
		<el-form ref="ruleForm" label-width="30px" class="demo-ruleForm">
			<el-form-item>
				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				<div style="margin: 15px 0"></div>

				<div style="max-height: 400px; overflow-y: auto">
					<el-checkbox-group v-model="checkedDt" @change="handleCheckedCitiesChange">
						<el-checkbox v-for="(m, n) in delModDt" :label="m" :key="n" :disabled="n == 0" style="width: 110px">样品详情{{ n + 1 }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</el-form-item>

			<el-form-item>
				<el-button @click="$refs['ruleForm'].resetFields(), (dialogVisible = false)">取消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
export default {
	props: ['delModDt', 'orderId'],
	data() {
		return {
			dialogVisible: false,
			checkAll: false,
			checkedDt: [],
			isIndeterminate: true,
			list: [],

			// contLoading: true,
		}
	},
	watch: {
		delModDt: {
			handler: function (val) {
				console.log(val,'valhhhhhhhhhhhhhhh')
				this.$nextTick(() => {
					this.checkedDt = val ? JSON.parse(JSON.stringify(val)).slice(1) : []
					this.list = val ? JSON.parse(JSON.stringify(val)).slice(1) : []
					// this.contLoading = false
				})
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		handleCheckAllChange(val) {
			this.checkedDt = val ? this.list : []
			this.isIndeterminate = false
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length
			this.checkAll = checkedCount === this.list.length
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length
		},
		submitForm() {
			console.log(this.checkedDt,'this.checkedDt')
			if (!this.checkedDt.length) return this.$message.warning('至少选择一条数据！')
			this.$emit('batchDelHandle', this.checkedDt)
			this.dialogVisible = false
		},
	},
}
</script>

<style>
</style>